<div class="sh-page-section--extrawide">
  @if (disclaimerContent$ | async; as disclaimerContent) {
    <sh-page-header [title]="disclaimerContent.title"></sh-page-header>
    <sh-detail-layout>
      <ng-template #main>
        <div class="sh-sticky-header">
          <sh-scrollspy-nav [items]="scrollspyNavItems$ | async"></sh-scrollspy-nav>
        </div>
        @for (section of disclaimerContent.sections; track section) {
          @if (section.sectionTitle) {
            <h4 [id]="section.sectionTitle">
              <sh-html-parser [message]="section.sectionTitle"></sh-html-parser>
            </h4>
          }
          @for (paragraph of section.paragraphs; track paragraph) {
            <p class="sh-notification__msg">
              <span [innerHtml]="paragraph"></span>
            </p>
          }
        }
      </ng-template>
    </sh-detail-layout>
  } @else {
    <sh-notification [type]="notificationType.Error" [message]="'errors.translation-not-found' | translate" [icon]="'delete'"></sh-notification>
  }
</div>

